import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { Tabs, Tab, Typography, Button } from '@material-ui/core';
import clsx from 'clsx';

// CONSTANTS
import appsListStatuses from '@/constants/app';
import { ROUTE_DISCOVER } from '@/constants/routes';
import { LOCATIONS_HOME_PAGE, LOCATIONS_ON_CARD } from '@/constants/locations';
import { HOME_PAGE } from '@/constants/swimlanes';

// UTILITY
import { analyticsUpdateAppListStatus } from '@/utility/analytics';

// COMPONENTS
import Loader from '@/components/Loader';
import Swimlanes from '@/components/Swimlanes';

// COMPONENTS
import Link from '@/components/Link';

// STORE
import { AppDetailsActions, HomeActions } from '@/store/actions';

// STYLES
import { Container } from './styles';

const Services = ({ content, loading }) => {
  const [t] = useTranslation();
  const [tab, setTab] = React.useState(1);
  const [mount, setMount] = React.useState(true);
  const dispatch = useDispatch();
  const { partner, user, section1, section1Loadings } = useSelector(state => ({
    isAuth: state.auth.isAuth,
    partner: state.partner.data,
    user: state.auth.user,
    section1: state.swimlanes.section1[HOME_PAGE] || {},
    section1Loadings: state.swimlanes.loadings.section1[HOME_PAGE] || {},
  }));

  const toggleMount = () => {
    setMount(false);
    setTimeout(() => {
      setMount(true);
    }, 1);
  };

  React.useEffect(() => {
    const requestData = {
      section: 1,
      tab,
    };

    toggleMount();

    dispatch(HomeActions.getHomeSection.action(requestData));
  }, [tab]);

  const tabsOptions = [
    { name: content['tab-1-title'], id: 1 },
    { name: content['tab-2-title'], id: 2 },
    { name: content['tab-3-title'], id: 3 },
  ];

  const handleTabs = (event, val) => setTab(val);

  const handleUpdateAppStatus = (data, status) => {
    const requestData = [{ app_id: data.id, status }];

    if (status) {
      dispatch(AppDetailsActions.appListUpdateAppStatuses.action(requestData));

      if (status === appsListStatuses.have) {
        analyticsUpdateAppListStatus('Added App To Profile', {
          app_id: data.id,
          app_name: data.name,
          user_id: user?.id || '',
          location: LOCATIONS_ON_CARD,
          partner_id: partner.id || 0,
        });
      }
    } else {
      dispatch(AppDetailsActions.appListUpdateAppStatuses.action(requestData));
    }
  };

  return (
    <Container className="section section--grey services content-visibility--auto">
      <div className="page-content">
        <Typography className="m-b-10" variant="h3" align="center">
          {content['what-services-title']}
        </Typography>
        <Typography variant="subtitle2" align="center">
          {t('home.services.subtitle')}
        </Typography>
        <div className="services__content">
          <Tabs
            variant="scrollable"
            className="services__tabs"
            onChange={handleTabs}
            value={tab}
            textColor="inherit"
            scrollButtons="off"
          >
            {tabsOptions.map(option => {
              const label = <span>{option.name}</span>;

              return <Tab key={`item-${option.id}`} value={option.id} label={label} {...option} />;
            })}
          </Tabs>
          <div
            className={clsx('services__tabs-content', !mount && 'services__tabs-content--unmount')}
          >
            {mount && (
              <Swimlanes
                data={section1}
                loadingType="app"
                loadings={section1Loadings}
                loadingRows={1}
                analyticsLocation={LOCATIONS_HOME_PAGE}
                handleUpdateAppStatus={handleUpdateAppStatus}
                hideTitle
                hideMobileNav
              />
            )}
          </div>
        </div>
        <Button
          className="services__btn"
          color="primary"
          component={Link}
          to={ROUTE_DISCOVER}
          location={LOCATIONS_HOME_PAGE}
        >
          {t('buttons.exploreMarketplace')}
        </Button>
        <Loader active={loading} />
      </div>
    </Container>
  );
};

Services.propTypes = {
  content: PropTypes.object.isRequired,
  loading: PropTypes.bool,
};

export default React.memo(Services);
